/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljg1MDAxIDMuNDA5OTdMOS4xNjAwMSA0LjA5OTk3TDExLjE5IDYuMTM5OTdIMS41NzAwMVY3LjEwOTk3SDEyLjE3TDEzLjA2IDcuOTk5OTdMMTIuMTcgOC44ODk5N0gxLjU3MDAxVjkuODU5OTdIMTEuMTlMOS4xNjAwMSAxMS45TDkuODUwMDEgMTIuNTlMMTQuNDMgNy45OTk5N0w5Ljg1MDAxIDMuNDA5OTdaIiBmaWxsPSJpbmhlcml0Ii8+";